// data/BlogData.js
import img1 from '../../assets/photos/blog1.jpg';
import img2 from '../../assets/photos/IMG_4842.jpg';
import img3 from '../../assets/photos/why1.jpg';

const BlogData = [
  {
    slug: 'uyuni-wedding-guide',
    title: 'Plan Your Perfect Wedding in Salar de Uyuni',
    date: 'Dec 31, 2024',
    image: img1,
    content: [
      "Imagine exchanging vows on a vast white canvas that stretches as far as the eye can see...",
      "• Choose Your Season: Dry (May–Nov) = white. Wet (Dec–Apr) = reflections.",
      "• Set Your Budget: Travel, lodging, catering, photography.",
      "• Book Early: 9–12 months in advance.",
      "• Legal Requirements: Bolivian documents.",
      "• Ceremony Details & Photography: Be creative.",
      "A salt flat wedding is an unforgettable experience. Plan it right and it becomes a dream come true."
    ]
  },
  {
    slug: 'uyuni-destination-benefits',
    title: 'Why a Destination Wedding in Uyuni is the Perfect Choice',
    date: 'Dec 24, 2024',
    image: img2,
    content: [
      "Uyuni is surreal. Here's why it's perfect:",
      "1. Natural Wonder for Your Big Day",
      "2. Breathtaking Wedding Photos in dry or wet season",
      "3. Total Intimacy & Exclusivity",
      "4. Bolivian Traditions & Custom Themes",
      "5. Destination Wedding + Honeymoon in one",
      "Uyuni is not just a place — it's a feeling. A wedding here is a once-in-a-lifetime experience."
    ]
  },
  {
    slug: 'uyuni-step-guide',
    title: 'How to Plan the Perfect Uyuni Wedding: A Step-by-Step Guide',
    date: 'Nov 26, 2024',
    image: img3,
    content: [
      "Step 1: Pick the right season – Dry (classic white) or Wet (mirror effect)",
      "Step 2: Reserve hotels early – Palacio de Sal, Luna Salada",
      "Step 3: Get an experienced Uyuni photographer",
      "Step 4: Add local Andean rituals (Ch’alla, live music, textiles)",
      "Step 5: Organize guest excursions (sunrise tours, stargazing)",
      "Step 6: Work with local planners for logistics",
      "You’re not just planning a wedding — you’re planning an epic journey."
    ]
  }
];

export default BlogData;
